import { render, staticRenderFns } from "./TrainersActivityList.vue?vue&type=template&id=237c8721&scoped=true"
import script from "./TrainersActivityList.vue?vue&type=script&lang=js"
export * from "./TrainersActivityList.vue?vue&type=script&lang=js"
import style0 from "./TrainersActivityList.vue?vue&type=style&index=0&id=237c8721&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c8721",
  null
  
)

export default component.exports